var map = {
  "./cs.messages.tsx": [
    "3612",
    [
      2766
    ]
  ],
  "./en.messages.tsx": [
    "64097",
    [
      1121
    ]
  ],
  "./sl.messages.tsx": [
    "39105",
    [
      229
    ]
  ],
  "./hu.messages.tsx": [
    "93273",
    [
      8845
    ]
  ],
  "./de.messages.tsx": [
    "14917",
    [
      2601
    ]
  ],
  "./it.messages.tsx": [
    "45855",
    [
      339
    ]
  ],
  "./pl.messages.tsx": [
    "98670",
    [
      9044
    ]
  ],
  "./sk.messages.tsx": [
    "38164",
    [
      9046
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 37703;
module.exports = __rspack_async_context;
